module.exports = __webpack_public_path__ + "img/team_4.4756a724.jpg";